//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TEnrollList from '@/TShareComponent/TSharePrepareEnroll/TEnrollList'
import { queryOpenBatchEnrollList } from '@/https/prepareEnroll'

export default {
  components: { TEnrollList },

  data () {
    return {
      batchEnrollList: [],
      loading: false,
      emptyMsg: '当前没有开通的招生批次，敬请等待！',
    }
  },

  async created () {
    await this.setBatch()
  },

  methods: {
    async setBatch () {
      this.loading = true
      const { data } = await queryOpenBatchEnrollList({ pcdm: this.$route.query.pcdm })
      this.batchEnrollList = data || []
      this.loading = false
    },
  },
}
